import config from '../../../config.js';

import {
  renderSelectTools,
  renderSelectGrades,
  renderSelectPeople,
  renderSelectSchool,
  renderInputJobTitle,
  renderSelectDepartments,
  renderToolLabel
} from './renderHelpers.js';

import {
  EVENT_INIT_FORM,
  EVENT_UPDATED_PERSON,
  EVENT_UPDATED_SCHOOL,
  EVENT_UPDATED_TOOL
} from './consts';

export function render(state, event, debug = config.shouldDebugRender) {
  if (debug) {
    console.group({event});
    console.log({state});
    console.groupEnd();
  }

  switch (event) {
    case EVENT_INIT_FORM:
      renderSelectSchool(state);
      break;

    case EVENT_UPDATED_SCHOOL:
      renderSelectPeople(state);
      break;

    case EVENT_UPDATED_PERSON:
      renderSelectTools(state);
      renderToolLabel(state);
      renderSelectDepartments(state);
      renderSelectGrades(state);
      renderInputJobTitle(state);
      break;

    case EVENT_UPDATED_TOOL:
      renderToolLabel(state);
      break;

    default:
      break;
  }
}
